import React, { ComponentProps, PropsWithChildren } from "react";
import { useLabels } from "../../../hooks/useLabels";
import { Modal } from "../../modal";
import { AlertDialog } from "./alert-dialog";

export const AlertDialogContainer = ({
	children,
	onOk,
	okLabel,
	message,
	messageHtml,
	messageLabel,
	messageHtmlLabel,
	titleLabel,
	...modalProps
}: PropsWithChildren<
	{
		titleLabel: eXpress.creator.LabelRequest;
		okLabel: eXpress.creator.LabelRequest;
		message?: string;
		messageHtml?: string;
		messageLabel?: eXpress.creator.LabelRequest;
		messageHtmlLabel?: eXpress.creator.LabelRequest;
	} & Pick<ComponentProps<typeof AlertDialog>, "onOk"> &
		ComponentProps<typeof Modal>
>) => {
	const [[ok, title, messageHtmlFromLabel, messageFromLabel], areLabelsLoading] = useLabels([
		okLabel,
		titleLabel,
		messageHtmlLabel,
		messageLabel,
	]);

	return areLabelsLoading ? null : (
		<AlertDialog
			title={title}
			ok={ok}
			onOk={onOk}
			messageHtml={messageHtml ?? messageHtmlFromLabel}
			{...modalProps}
		>
			{message ?? messageFromLabel}
			{children}
		</AlertDialog>
	);
};
AlertDialogContainer.displayName = "AlertDialogContainer";
